<template>
    <v-card :class="{'pa-3': $vuetify.breakpoint.xs, 'pa-5': $vuetify.breakpoint.smAndUp}"
            :width="$vuetify.breakpoint.lgAndUp ? 1134 : 'auto'"
    >
        <v-form @submit.prevent>
            <v-icon class="modal-close" @click.native="CLOSE_MODAL('add_organization')" aria-hidden="true" translate="no">close</v-icon>
            <v-card-title class="display-1 mb-4">{{ $t("Добавить новую организацию") }}</v-card-title>
            <v-layout mb-4 wrap align-center
                      justify-space-left
            >
                <v-flex v-if="show_foreign_subsidiary" md4 sm6
                        xs12
                        mb-4 :class="{'pr-4': $vuetify.breakpoint.mdAndUp}"
                >
                    <div class="grey-text mb-2">{{ $t('ЗДО') }} *</div>
                    <v-autocomplete
                        v-model="new_org.foreign_subsidiary"
                        :items="companies_form.foreign_subsidiary"
                        solo
                        attach="js-country"
                        append-icon=""
                        :label="$t('Введите ЗДО')"
                        class="input js-country"
                        item-value="id"
                        :class="{ 'form-group--error': $v.new_org.foreign_subsidiary.$error }"
                        @change="set_foreign_subsidiary($event)"
                    >
                      <template #append>
                        <v-icon aria-hidden="true" translate="no">
                          expand_more
                        </v-icon>
                      </template>
                    </v-autocomplete>
                </v-flex>
                <v-flex md4 sm6 xs12
                        mb-4 :class="{'pr-4': $vuetify.breakpoint.smAndUp}"
                >
                    <div class="grey-text mb-2">{{ $t("Название") }} *</div>
                    <inputBase :placeholder="$t('Введите название')" :class="{ 'form-group--error': $v.new_org.name.$error }"
                               :value="new_org.name" @input="set_org_name($event.target.value)"
                    />
                </v-flex>
                <v-flex md4 sm6 xs12
                        mb-4 :class="{'pr-4': $vuetify.breakpoint.mdAndUp}"
                >
                    <div class="grey-text mb-2">{{ $t('Страна') }} *</div>
                    <v-autocomplete
                        v-model="new_org.country"
                        :items="companies_form.countries"
                        solo
                        attach="js-country"
                        append-icon=""
                        :label="$t('Введите страну')"
                        class="input js-country"
                        item-value="id"
                        :class="{ 'form-group--error': $v.new_org.country.$error }"
                        @change="set_country($event)"
                    >
                      <template #append>
                        <v-icon aria-hidden="true" translate="no">
                          expand_more
                        </v-icon>
                      </template>
                    </v-autocomplete>
                </v-flex>
                <v-flex md4 sm6 xs12
                        mb-4 :class="{'pr-4': $vuetify.breakpoint.mdAndUp}"
                >
                    <div class="grey-text mb-2">{{ $t("Регион") }} *</div>
                    <v-autocomplete
                        :disabled="new_org.country_iso !== 'RU'"
                        :items="companies_form.regions"
                        :value="new_org.region"
                        solo
                        attach="js-region"
                        append-icon=""
                        :label="$t('Введите регион')"
                        class="input js-region"
                        item-value="id"
                        :class="{ 'form-group--error': ($v.new_org.region.$error)}"
                        @change="set_region($event)"
                    >
                      <template #append>
                        <v-icon aria-hidden="true" translate="no">
                          expand_more
                        </v-icon>
                      </template>
                    </v-autocomplete>
                </v-flex>
                <v-flex md4 sm6 xs12
                        mb-4 :class="{'pr-4': $vuetify.breakpoint.mdAndUp}"
                >
                    <div class="grey-text mb-2">{{ $t("Город") }} *</div>
                    <v-select
                        :disabled="new_org.country_iso !== 'RU'"
                        :items="show_cities ? cities_filtered : ['-']"
                        :value="new_org.city"
                        solo
                        attach="js-city"
                        append-icon=""
                        :label="$t('Введите город')"
                        class="input js-city"
                        item-value="id"
                        :class="{ 'form-group--error': ($v.new_org.city.$error) }"
                        @change="set_city($event)"
                    >
                      <template #append>
                        <v-icon aria-hidden="true" translate="no">
                          expand_more
                        </v-icon>
                      </template>
                    </v-select>
                </v-flex>
                <v-flex md4 sm6 xs12
                        mb-4 :class="{'pr-4': $vuetify.breakpoint.smAndUp}"
                >
                    <div class="grey-text mb-2">{{ $t("Адрес") }} *</div>
                    <inputBase :placeholder="$t('Введите адрес')" :class="{ 'form-group--error': $v.new_org.address.$error }"
                               :value="new_org.address" @input="set_address($event.target.value)"
                    />
                </v-flex>
                <v-flex md4 sm6 xs12
                        mb-4 :class="{'mb-40': $vuetify.breakpoint.smAndUp, 'pr-4': $vuetify.breakpoint.mdAndUp}"
                >
                    <div class="grey-text mb-2">{{ $t("Тип организации") }}</div>
                    <v-select
                        :items="companies_form.types"
                        solo
                        attach="js-type"
                        append-icon=""
                        :label="$t('Выберите организацию')"
                        class="input js-type"
                        @change="set_type($event)"
                    >
                      <template #append>
                        <v-icon aria-hidden="true" translate="no">
                          expand_more
                        </v-icon>
                      </template>
                    </v-select>
                </v-flex>
                <!--<v-flex md4 sm6 xs12-->
                <!--mb-4 :class="{'pr-4': $vuetify.breakpoint.smAndUp}" class="wrapper-relative"-->
                <!--&gt;-->
                <!--<div class="grey-text mb-2">{{ $t("Логотип") }}</div>-->
                <!--<inputUpload id="logo_upload" size="64000" :placeholder="$t('Загрузить логотип...')"-->
                <!--:class="{ 'form-group&#45;&#45;error': $v.file_size.$error }"-->
                <!--@input.native="send_file($event)"-->
                <!--@setFile="set_file_size"-->
                <!--/>-->
                <!--<div class="grey-text" style="position: absolute;">{{ $t("Файлы в формате jpg., png. не более 64 КБ") }}</div>-->
                <!--</v-flex>-->
                <v-flex md4 sm6 xs12
                        mb-4 :class="{'pr-4': $vuetify.breakpoint.mdAndUp}"
                >
                    <div class="grey-text mb-2">{{ $t("Номер телефона") }}</div>
                    <inputBase v-mask="phoneMask" v-model="phoneNumber" :placeholder="$t('Введите номер')"
                               :class="{'form-group--error': $v.new_org.phone_number.$error }"
                    />
                    <!--          <inputBase v-else placeholder="Введите номе" v-model="phoneNumber" />-->
                </v-flex>
                <v-flex md4 sm6 xs12
                        mb-4 :class="{'pr-4': $vuetify.breakpoint.smAndUp}"
                >
                    <div class="grey-text mb-2">E-mail</div>
                    <inputBase :placeholder="$t('Введите e-mail')" :class="{ 'form-group--error': $v.new_org.email.$error }"
                               :value="new_org.email" @input="set_email($event.target.value)"
                    />
                </v-flex>
                <!-- <v-flex md4 sm6 xs12
                mb-4 :class="{'mt-4': $vuetify.breakpoint.xs, 'pr-4': $vuetify.breakpoint.mdAndUp}"
        >
            <div class="grey-text mb-2">{{ $t("Управление") }}</div>
            <v-select
                :items="companies_form.departments"
                solo
                attach="js-depart"
                append-icon="expand_more"
                :label="$t('Выберите отдел')"
                class="input js-depart"
                @change="set_department($event)"
            />
        </v-flex>
        <v-flex md4 sm6 xs12
                mb-4 :class="{'pr-4 mt-4': $vuetify.breakpoint.sm}"
        >
            <div class="grey-text mb-2">{{ $t("Группа организаций") }}</div>
            <v-select
                :items="companies_form.groups"
                solo
                attach="js-group"
                append-icon="expand_more"
                :label="$t('Выберите группу')"
                class="input js-group"
                @change="set_group($event)"
            />
        </v-flex> -->
                <v-flex xs12 mb-4 mt-4>
                    <div style='display: flex; align-items: center'>
                        <checkbox :checked='catalog_access' @input="check_access" />
                        <label style="margin-right: 10px" class="v-label theme--light">{{ $t("Доступ к Мотивационной программе") }}</label>

                    </div>
                </v-flex>
                <v-flex xs12 mb-4 mt-4>
                    <div class="grey-text mb-2">{{ $t("Деятельность организации") }}</div>
                    <textareaBase :placeholder="$t('Введите текст')" rows="4" @change="set_about($event.target.value)" />
                </v-flex>

            </v-layout>
            <v-card-actions>
                <v-layout align-center wrap>
                    <buttonRed :class="{'flex xs12': $vuetify.breakpoint.xs}" @click.native="send_new_org(new_org)">
                        {{ $t("Добавить") }}
                    </buttonRed>
                    <div class="grey-text"
                         :class="{'mt-2': $vuetify.breakpoint.xs, 'ml-4': $vuetify.breakpoint.smAndUp}"
                    >{{ $t('* - поля, обязательные для заполнения') }}
                    </div>
                </v-layout>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import buttonRed from '@/components/ui/buttons/button_red';
import inputBase from '@/components/ui/inputs/base/input';
import inputUpload from '@/components/ui/inputs/typed/input_upload.vue';
import textareaBase from '@/components/ui/inputs/base/textarea';
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';
import {required, helpers, email, between} from 'vuelidate/lib/validators';
import {validationMixin} from 'vuelidate';
import {VueMaskDirective} from 'v-mask';
import Checkbox from '@inputs/base/checkbox.vue';

const optionalRegionCity = (param) =>
  (value) => param !== 'RU' || helpers.req(value);

const optionalForeignSubsidiary = (param) => (value) => {
  return !param || helpers.req(value);
};

export default {
  directives: {
    'mask': VueMaskDirective,
  },
  components: {
    buttonRed,
    inputBase,
    inputUpload,
    textareaBase,
    Checkbox,
  },
  mixins: [validationMixin],
  validations() {
    return {
      file_size: {
        between: between(0, 64000),
      },
      new_org: {
        name: {
          required,
        },
        email: {
          email,
        },
        region: {
          optionalRegionCity: optionalRegionCity(this.new_org.country_iso),
        },
        city: {
          optionalRegionCity: optionalRegionCity(this.new_org.country_iso),
        },
        country: {
          required,
        },
        address: {
          required,
        },
        phone_number      : {},
        foreign_subsidiary: {
          optionalForeignSubsidiary: optionalForeignSubsidiary(this.show_foreign_subsidiary),
        },
      },
    };
  },
  data() {
    return {
      'file_size'     : 0,
      'catalog_access': false,
      'new_org'       : {
        'name'              : '',
        'catalog_access'    : false,
        'image'             : '',
        'type'              : 0,
        'phone_numbers'     : [],
        'phone_number'      : '',
        'email'             : '',
        'country'           : '',
        'country_iso'       : '',
        'region'            : '',
        'city'              : '',
        'group'             : 0,
        'llk'               : 0,
        'address'           : '',
        'about'             : '',
        'foreign_subsidiary': '',
      },
      'request_new_org': {
        'name'      : '',
        'type'      : '',
        'group'     : '',
        'logo'      : '',
        'department': '',
      },
      'show_cities'            : false,
      'show_foreign_subsidiary': false,
    };
  },
  computed: {
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('users/modals', [
      'add_user',
      'add_organization',
      'companies_form',
      'cities_filtered',
    ]),
    ...mapGetters('users/organizations', [
      'groups',
      'types',
      'departments',
    ]),
    phoneMask() {
      let iso = this.new_org.country_iso;
      return !iso || iso === 'RU' ? '+7(###)-###-##-##' : '';
    },
    phoneNumber: {
      set(ev) {
        let val = ev.target.value;
        this.new_org.phone_number = val;
        this.new_org.phone_numbers[0] = val;
      },
      get() {
        return this.new_org.phone_number;
      },
    },
  },
  mounted() {
    if (localStorage.user !== undefined) {
      this.show_foreign_subsidiary = this.user.role_code === 'ADMINISTRATOR';
    }

    this.get_companies_form();
  },
  methods: {
    ...mapState('users/organizations', [
      'update_organizations',
    ]),
    ...mapMutations('users/modals', [
      'OPEN_MODAL',
      'CLOSE_MODAL',
      'CHOOSE_REGION',
    ]),
    ...mapMutations('users/organizations', [
      'ADD_ORG',
      'SET_UPDATE_ORGANIZATIONS',
    ]),
    ...mapActions('users/requests', [
      'add_new_request',
    ]),
    ...mapActions('users/modals', [
      'get_companies_form',
    ]),
    ...mapActions('users/organizations', [
      'add_new_org',
      'accept_new_org',
      'update_table',
    ]),

    check_access() {
      this.catalog_access = !this.catalog_access;
      this.new_org.catalog_access = this.catalog_access;
    },

    set_file_size($event) {
      this.file_size = $event;
      this.$v.file_size.$touch();
    },
    set_org_name(ev) {
      this.$v.new_org.name.$touch();
      this.new_org.name = ev;
      this.request_new_org.name = ev;
    },
    set_country(ev) {
      this.$v.new_org.country.$touch();
      let chosen_country = this.companies_form.countries.find((item) => item.id == ev);
      this.new_org.country = ev;
      this.new_org.country_iso = chosen_country.iso;

      if (chosen_country.iso !== 'RU') {
        this.new_org.city = '';
        this.new_org.region = '';
      }
    },
    set_region(ev) {
      this.$v.new_org.region.$touch();
      let chosen_region = this.companies_form.regions.find((item) => item.id == ev);
      this.new_org.region = ev;
      this.show_cities = true;
      this.CHOOSE_REGION(chosen_region);
    },
    set_city(ev) {
      this.new_org.city = ev;
    },
    set_phone(ev) {
      this.new_org.phone_numbers[0] = ev;
    },
    set_email(ev) {
      this.new_org.email = ev.trim();
      this.$v.new_org.email.$touch();
    },
    set_address(ev) {
      this.new_org.address = ev;
      this.$v.new_org.address.$touch();
    },
    send_file($event) {
      let files = $event.target.files;
      let reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = () => {
        this.new_org.image = reader.result;
        // this.request_new_org.logo = reader.result;
      };
    },
    set_department(ev) {
      this.request_new_org.department = ev;
      this.new_org.llk = Number(this.companies_form.departments.find((item) => item.text == ev).id);
    },
    set_group(ev) {
      this.request_new_org.group = ev;
      this.new_org.group = Number(this.companies_form.groups.find((item) => item.text == ev).id);
    },
    set_type(ev) {
      this.request_new_org.type = ev;
      this.new_org.type = Number(this.companies_form.types.find((item) => item.text == ev).id);
    },
    set_about(ev) {
      this.new_org.about = ev;
    },
    set_foreign_subsidiary(ev) {
      this.$v.new_org.foreign_subsidiary.$touch();
      this.new_org.foreign_subsidiary = ev;
    },
    async send_new_org(org) {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        if (this.user.external) {
          await this.add_new_org(this.new_org);
          await this.add_new_request({request: this.new_org, type: 'org'});
        } else {
          await this.add_new_org(this.new_org);
          await this.accept_new_org(this.request_new_org);
        }

        this.update_table();
        this.CLOSE_MODAL('add_organization');
      }
    },
  },
};
</script>
